export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_PUBLIC_SITE === 'true') {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}/api`;
    }
    return '/api';
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }

  return 'http://localhost:5000/api';
};

export const getApiOrigin = () => getApiBaseUrl().replace(/\/api\/?$/, '');
